import React from "react";
import { Chart } from "react-google-charts";
import Spinner from "../../../spinner/spinner";

export default function SupplierOutstandingChart({ data, loading, showChart }) {

    const options = {
        title: 'Supplier Outstanding Amounts by Days Range',
        fontSize: 15,
        chartArea: {
            width: "50%",
        },
        hAxis: {
            title: 'Days Range',
            titleTextStyle: {
                color: '#333',
                bold: true
            },
            textStyle: {
                color: '#333'
            },
        },
        vAxis: {
            title: 'Outstanding Amount (LKR)',
            titleTextStyle: {
                color: '#333',
                bold: true
            },
            textStyle: {
                color: '#333'
            },
        },
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            {loading ? (
                <Spinner />
            ) : (
                <React.Fragment>
                    {showChart ? (
                        data.length > 1 ? (
                            <Chart
                                chartType="ColumnChart"
                                width="100%"
                                height="400px"
                                data={data}
                                options={options}
                            />
                        ) : (
                            <h3>No Data Available</h3>
                        )
                    ) : null}
                </React.Fragment>
            )}
        </div>
    );
}